/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigniusVerificationInitResponseDto
 */
export interface SigniusVerificationInitResponseDto {
    /**
     * URL the user must visit to complete identity verification
     * @type {string}
     * @memberof SigniusVerificationInitResponseDto
     */
    verificationUrl: string;
}

/**
 * Check if a given object implements the SigniusVerificationInitResponseDto interface.
 */
export function instanceOfSigniusVerificationInitResponseDto(value: object): value is SigniusVerificationInitResponseDto {
    if (!('verificationUrl' in value) || value['verificationUrl'] === undefined) return false;
    return true;
}

export function SigniusVerificationInitResponseDtoFromJSON(json: any): SigniusVerificationInitResponseDto {
    return SigniusVerificationInitResponseDtoFromJSONTyped(json, false);
}

export function SigniusVerificationInitResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigniusVerificationInitResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationUrl': json['verificationUrl'],
    };
}

export function SigniusVerificationInitResponseDtoToJSON(json: any): SigniusVerificationInitResponseDto {
    return SigniusVerificationInitResponseDtoToJSONTyped(json, false);
}

export function SigniusVerificationInitResponseDtoToJSONTyped(value?: SigniusVerificationInitResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verificationUrl': value['verificationUrl'],
    };
}

